import { useTranslation } from "react-i18next";
import { Building2, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { PeritoCompanySelector } from "./PeritoCompanySelector";

/**
 * El perito está en una empresa cliente que ha dejado de pagar (tanda 5, M40 /
 * T15-06).
 *
 * Antes le salía `SubscriptionExpiredPage`: encerrado, sin poder pasar a sus
 * otras empresas y con botones de pago de un cliente que no es suyo. Ahora:
 *  · si tiene otra empresa con suscripción → el selector, con la caducada marcada;
 *  · si no → una pantalla propia, SIN pagos: que hable con la empresa, y salir.
 */
export function PeritoEmpresaSinSuscripcion() {
  const { t } = useTranslation();
  const { company, profile, linkedCompanies, switchCompany, signOut } = useAuth();
  const nombre = company?.name ?? "";
  const otras = linkedCompanies.filter((c) => c.company_id !== profile?.company_id && c.is_usable !== false);

  if (otras.length > 0) {
    return (
      <PeritoCompanySelector
        companies={linkedCompanies.map((c) =>
          c.company_id === profile?.company_id ? { ...c, is_usable: false } : c,
        )}
        currentCompanyId={profile?.company_id || null}
        aviso={t("perito.invitacion.empresaSinSuscripcionElige", { empresa: nombre })}
        onSelect={async (companyId) => {
          await switchCompany(companyId);
          try {
            localStorage.setItem("perito_company_selected", "true");
          } catch {
            /* sin almacenamiento, el selector vuelve a salir la próxima vez: no pasa nada */
          }
        }}
      />
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg-page)" }}>
      <div className="w-full max-w-md space-y-5 rounded-2xl border border-[#E4EDF5] bg-white p-6 text-center shadow-sm" data-testid="perito-sin-suscripcion">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-muted">
          <Building2 className="h-6 w-6 text-muted-foreground" />
        </div>
        <h1 className="text-xl font-bold text-foreground">{t("perito.invitacion.empresaSinSuscripcionTitulo", { empresa: nombre })}</h1>
        <p className="text-sm text-muted-foreground">{t("perito.invitacion.empresaSinSuscripcionTexto", { empresa: nombre })}</p>
        <Button variant="outline" className="w-full gap-2" onClick={() => void signOut()}>
          <LogOut className="h-4 w-4" />
          {t("auth.signOut")}
        </Button>
      </div>
    </div>
  );
}
